"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickableIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const color_1 = require("../../constants/color");
const Clickable_1 = require("../Clickable");
const Icon_1 = require("../Icon");
const Tooltip_1 = require("../Tooltip");
// TODO: shouldn't icon inherit color?
const Hoverable = (0, styled_1.default)(Clickable_1.Clickable)({
    border: `1px solid ${color_1.Color.TRANSPARENT}`,
    borderRadius: constants_1.theme.border.radius.small,
    padding: constants_1.theme.spacing[1],
    flex: 0,
    ':not(:disabled):hover': {
        borderColor: color_1.Color.GREY,
        background: color_1.Color.LIGHT_GREY,
        div: {
            color: color_1.Color.BLUE,
        },
    },
});
const ClickableIcon = (props) => {
    const content = ((0, jsx_runtime_1.jsx)(Hoverable, { ...props.clickableProps, disabled: props.disabled, onClick: props.onClick, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { ...props.iconProps }) }));
    return props.tooltipText ? ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, { text: props.tooltipText, children: (0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip.Trigger, { asChild: true, children: content }) })) : (content);
};
exports.ClickableIcon = ClickableIcon;
